// extracted by mini-css-extract-plugin
export var quantityInput = "_er-0";